import {
	createImageUrlBuilder,
	type SanityImageSource,
} from "@sanity/image-url";
import { dataset, projectId } from "../env";

const imageBuilder = createImageUrlBuilder({
	projectId: projectId || "",
	dataset: dataset || "",
});

export const urlForImage = (source: SanityImageSource) => {
	return imageBuilder?.image(source).quality(100).auto("format");
};
